import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import Calendar from "../../calendar/Calendar";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputCombo from "../../helpers/InputCombo";
import MenuTable from "../../helpers/MenuTable";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import { fireEvent } from "@testing-library/react";
import InputTime from "../../helpers/InputTime";
import CalendarYearForm from "./CalendarYearForm";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import InputComboDzien from "../../helpers/InputComboDzien";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboRokMiesiac from "../../helpers/InputComboRokMiesiac";




function CalendarYear(props)
{

   const [errTab, setErrTab] = useState([]);  //z info od serwera..

   const [refreshView, setRefreshView] = useState(props.userData.refreshView);
   const [tab, setTab] = useState(null);

   const [list, setList] = useState(null);

   const tabRef = useRef(0); //do druku

  

 

   var dt = new Date();

   var strM = (dt.getMonth()+1)+"";
   if(strM.length == 1) strM = "0" + strM;

   var strD = dt.getDate()+"";
   if(strD.length == 1) strD = "0" + strD;

   var dateX  = dt.getFullYear()+"-"+strM+"-"+strD;

   
   const [view, setView] = useState('list');


   
   const [filter, setFilter] = useState(null);
   const [filterParam, setFilterParam] = useState({   
                
       p_grupa_id:  '_x_',
       rok: dt.getFullYear()+"",
       miesiac: strM + "",

       limit: 50,
       page: 1,
       pages: 1,
   });




   
    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = () => {
       
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
       
    }

 const onSukcess = () => {
       
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        getTab();
    }


   const [itemSelected, setItemSelected] = useState(2);
   const clickTab = (e) => {

       var t = e.target.getAttribute("atr-tab");
       setItemSelected(t);
   }


   const onMonthChange = (y,m) => {

      var rok = y;
      var miesiac =  m+"";
      if(miesiac.length < 2) miesiac = "0" + miesiac;

      var nData = rok + "-" + miesiac + "-01";
   

      setFilterParam({...filterParam, ["day"]: nData,["p_grupa_id"]:'_x_' });  
      getList(nData);
   }

 
   const clickOnDay = (date,title) => {      
      
   
      if( date != null && date.length > 2)
      {
         //setFilterParam({...filterParam, ["day"]: date,["p_grupa_id"]:'_x_' });                  
         setFilterParam({...filterParam, ["day"]: date,["p_grupa_id"]:'_x_' });    

         getList(date);
      }
    

  }



   const valChangeListener = (filedName, val, correct, msg) => {

 

      setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
      
      
      var modX = val.length % 3;
      if(  val.length == 0 || modX == 0 || msg =='combo')
      setTab();  

      props.mainView.writeFilter(filedName, val);
   }


   const valChangeListenerForm = (filedName, val, correct, msg) => {

 

      setTab( {...tab, [filedName]:val,  [filedName+"_valid"]:correct } );      
      props.mainView.writeFilter(filedName, val);
   }


   const goNextNew = () => {
    
      setTab(null);    
   }





   const getTab = (gId, d) => {
        
  

      props.mainView.setProgress(-2);     

      fetch( Config.url + '/rest_v1_news,kalendarz', {
          method: 'POST', 
          body: JSON.stringify(filterParam), 
          headers: {
              'Content-Type': 'application/json',                    
              'X-Api-Key': props.userData.apiKey,
              '_p_przedszkole_id_': props.userData.p_przedszkole_id,
              '_p_dziecko_id_': props.userData.p_dziecko_id,
              '_sec_key_': Config.genXKey() ,
          }
       })
       .then(res => res.json() )
       .then(res => { 

                  props.mainView.setProgress(-1);        
                  if(res._sys_ == undefined)
                  {
                      props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                  }else
                  if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                  {
                      props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                  }else    
                  {
                      setTab(res.result);   
                      getList(null);                                                                        
                  }
       } )
       .catch(err => {          
                  props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                  props.mainView.setProgress(-1);
       });
                 

       return false;
  }


  const getList = (dt ) => {
        

   var req = {
      ym: filterParam.rok + "-" + filterParam.miesiac,
   };

  

    props.mainView.setProgress(-2);     

    fetch( Config.url + '/rest_v1_news,kalendarz_list', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setList(res.result);      
                          
                   
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}



  const valChecker = (fields) => {

   var allValid = true;

         
   //console.log(JSON.stringify(fields) );

   Object.entries(fields).forEach(function(entry) {

       var xKey    = entry[0];
       var xValue  = entry[1];                    

       var xValidName = xKey + "_valid";

       if(fields[xValidName] == false)
       {
           allValid = false;
           console.log("Error field: " + xKey);
       }
       
     });
   
     return allValid;

}

  

   const goDelete = (e) => {

      var id = e.target.getAttribute("id");
      var title = e.target.getAttribute("title");



        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć \""+title+"\" ?", "yesno", (option)=>{


            if(option == 'yes')
            {

                        //-------------------------------------------------
                        //-------------------------------------------------
                  


                              props.mainView.setProgress(-2);

                              var req = {
                                    id: id
                              }

                              fetch( Config.url + '/rest_v1_news,kalendarz_del', {
                                    method: 'POST', 
                                    body: JSON.stringify(req), 
                                    headers: {
                                       'Content-Type': 'application/json',                    
                                       'X-Api-Key': props.userData.apiKey,
                                       '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                       '_p_dziecko_id_': props.userData.p_dziecko_id,
                                       '_sec_key_': Config.genXKey() ,
                                    }
                                 })
                                 .then(res => res.json() )
                                 .then(res => {             
                                          
                                          props.mainView.setProgress(-1);

                                          if(res._sys_ == undefined)
                                          {
                                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                          }else
                                          if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                          {
                                                props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                                          }else
                                          if(res.status != undefined && res.status == "OK")
                                          {
                                                props.mainView.showDialog( "Sukces",  "Wpis został usunięty", "ok" , null);                        
                                                setTab(null);
                                                setList(null);
                                          }else
                                          {
                                                props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                          }
                                          
                                 } )
                                 .catch(err => {   
                                          props.mainView.setProgress(-1);       
                                          props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                 });

                        //-------------------------------------------------
                        //-------------------------------------------------

            }

        });


    

   }



   var daysReview = new Array();

   daysReview.push({
         date: filterParam.rok + "-" + filterParam.dzien,
         title: "wybrano " + filterParam.rok + "-" + filterParam.dzien,
         className: "selected",
   });


   
   var dayContent = null;



   if(refreshView != props.userData.refreshView)
      {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
          setFilterParam({...filterParam,["p_grupa_id"]:"_x_" });
      }


      if(tab == null)
      {
         setTab([]);
         getTab();       
      }


      if(list == null)
      {
         setList([]);
         getList(null);
         return <div></div>
      }


 


 

   
   var cssTab1 = "";
   var cssTab2 = "";
 

   if(itemSelected == 1) cssTab1 = " xActive ";
   if(itemSelected == 2) cssTab2 = " xActive ";


 
 

   var rok      = filterParam.rok;
   var miesiac =  filterParam.miesiac;
   
   var d = new Date( parseInt(rok)  ,   parseInt(miesiac) , 0);   
   var lastDay = d.getDate();          

   d = new Date( parseInt( rok)  ,   parseInt(miesiac) - 1  , 1);   
   var dayWeek =  d.getDay();


 
   
   var calD = [
       [' ',' ',' ',' ',' ',' ',' '],
       [' ',' ',' ',' ',' ',' ',' '],
       [' ',' ',' ',' ',' ',' ',' '],
       [' ',' ',' ',' ',' ',' ',' '],
       [' ',' ',' ',' ',' ',' ',' '],
       [' ',' ',' ',' ',' ',' ',' '],
   ];

   var dayX = 0;

   for(var row=0; row<calD.length; row++)
   {
       for(var dd=0; dd<7; dd++)
       {
           if(dayX > lastDay) break;
           if(dd == 0 && dayWeek ==1 && dayX==0 ) {dayX = 1;}else
           if(dd == 1 && dayWeek ==2 && dayX==0 ) {dayX = 1;}else
           if(dd == 2 && dayWeek ==3 && dayX==0 ) {dayX = 1;}else
           if(dd == 3 && dayWeek ==4 && dayX==0 ) {dayX = 1;}else
           if(dd == 4 && dayWeek ==5 && dayX==0 ) {dayX = 1;}else
           if(dd == 5 && dayWeek ==6 && dayX==0 ) {dayX = 1;}else 
           if(dd == 6 && dayWeek ==0 && dayX==0 ) {dayX = 1;}else {}



           if(dayX == 0)
           {
               calD[row][dd] = {
                   date: '',
                   day: '',
                   title: '',
                   dw: '',
                   rows: new Array(),
               }; 
           }else
           {

               var strM = miesiac+"";
               if(strM.length == 1) strM = "0" + strM;

               var strD = dayX+"";
               if(strD.length == 1) strD = "0" + strD;

               var dateX  = rok+"-"+strM+"-"+strD;             
         
               var p = new Array();

     

              if( list != null)
              {                            
                   for(var kk=0; kk < list.length ; kk++)
                   {                 

                       if(list[kk].dzien == dateX)
                       {
                       // console.log(dateX, list[kk]);
                           p.push( list[kk] ) ;                           
                           //break;
                       }
                   }
              }





               calD[row][dd] = {
                   date: dateX,
                   day: dayX,
                   title: 'Pokaż',
                   dw: dd,
                   className: "",
                   rows: p,
               }; 
           }

           if(dayX>0)
           dayX++;
       }
   }

   if(calD[5][0] == ' ') {
       calD = calD.slice(0, -1);
   }


//console.log("CaldDAT", calD);

   var monthName = "";
   if(filterParam.miesiac == 1) monthName = "Styczeń";
   if(filterParam.miesiac == 2) monthName = "Luty";
   if(filterParam.miesiac == 3) monthName = "Marzec";
   if(filterParam.miesiac == 4) monthName = "Kwiecień";
   if(filterParam.miesiac == 5) monthName = "Maj";
   if(filterParam.miesiac == 6) monthName = "Czerwiec";
   if(filterParam.miesiac == 7) monthName = "Lipiec";
   if(filterParam.miesiac == 8) monthName = "Sierpień";
   if(filterParam.miesiac == 9) monthName = "Wrzesień";
   if(filterParam.miesiac == 10) monthName = "Październik";
   if(filterParam.miesiac == 11) monthName = "Listopad";
   if(filterParam.miesiac == 12) monthName = "Grudzień";


   //-----------------------------------------------------------------------------
   //-----------------------------------------------------------------------------
 
   
    if(view.v == 'new')
    {
        return <CalendarYearForm  userData={props.userData} mainView={props.mainView} onSukcess={onSukcess} onBack={onBack} id={-1} />
    }

     if(view.v == 'edit')
    {
        return <CalendarYearForm  userData={props.userData} mainView={props.mainView} onSukcess={onSukcess} onBack={onBack}  id={view.id}  />
    }



   return   <div className="view_content">
 



                                 <div className="bg_center">

                                                   

                                    <div className="xTabs">
                                             <div className={"xItem " + cssTab2 } atr-tab="2" onClick={clickTab}  >Edycja</div>   
                                             <div className={"xItem " + cssTab1 } atr-tab="1" onClick={clickTab}  >Podgląd</div>                                                                         
                                             <div className={"xEmpty "  }>&nbsp;</div>
                                    </div>

                                    <div>
                                       <br/>&nbsp;<br/>
                                    </div>

                              <div className="table_filter">
                                   <div className="filter_controll">   
                                                <label>Rok: </label>                             
                                                <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                                       </div>
                        
                                       <div className="filter_controll">   
                                                <label>Miesiąc: </label>                             
                                                <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  rok={filterParam.rok}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="0"   />
                                       </div>
                              </div>



                                    {
                                       itemSelected == 1 &&
                                       <Fragment>

                                       <br/>
                                       <div className="calColor">Zaplanowane na {filterParam.rok + "-" + filterParam.miesiac }</div>
                                       
                                       <br/>
                                        <div className="btn" onClick={changeView} v="new" id="-1"  >zaplanuj czynność</div>
                                       <br/>&nbsp; <br/>

                                          <div className="scorll_x">

                                                   <div className="calSchedule "  >
                                                                                       <table className="schedTab" >                                       
                                                                                          <tr className="days">                                                                                           
                                                                                             <td className="gocenter">PN</td>
                                                                                             <td className="gocenter">WT</td>
                                                                                             <td className="gocenter">ŚR</td>
                                                                                             <td className="gocenter">CZ</td>
                                                                                             <td className="gocenter">PT</td>
                                                                                             <td className="gocenter">SB</td>
                                                                                             <td className="gocenter">ND</td>
                                                                                          </tr>

                                                                                          {
                                                                                             calD.map( (week, ixWeek) => {
                                                                                                   return (
                                                                                                         <tr className="dinside">

                                                                                                               
                                                                                                                  {
                                                                                                                     week.map( (px, inxDay) => {


                                                                                                                           var classTD = "";

                                                                                                                           //if(px.dw == 5 || px.dw== 6) classTD = " cweek "
                                                                                                                           //if(px.dw == 5 || px.dw== 6 || inxDay == 6 || inxDay == 5) classTD = " cweek gohide"
                                                                                                                           if(px.dw == 5 || px.dw== 6 || inxDay == 6 || inxDay == 5) classTD = " cweek  "

                                                                                                                           classTD = classTD + " " + px.className;

                                                                                                                           return (                                                                            
                                                                                                                              <td className={"clink w7day  " + classTD}  >
                                                                                                                                 <div className="tdr" title={px.title} date={px.date} onClick={clickOnDay}>
                                                                                                                                 <b>{px.day}</b>&nbsp;                                                                                                                                       
                                                                                                                                 </div>
                                                   
                                                                                                                                  <div>
                                                                                                                                      {
                                                                                                                                             px.rows != undefined &&
                                                                                                                                             <Fragment>
                                                                                                                                                      {
                                                                                                                                                      px.rows.map( (item, iIx) => {
                                                                                                                                                            return <div className="wMax150" onClick={changeView} v="edit" id={item.id} >
                                                                                                                                                                     <span className="link_men " onClick={changeView} v="edit" id={item.id}>{item.godzina_wydarzenia},  {item.temat_dnia}</span>
                                                                                                                                                                     <br/>
                                                                                                                                                                     (
                                                                                                                                                                     {
                                                                                                                                                                        item.grupy.map( (gr,grInx) => {
                                                                                                                                                                          return <span onClick={changeView} v="edit" id={item.id}> 
                                                                                                                                                                              {gr.nazwa}&nbsp;
                                                                                                                                                                          </span> 
                                                                                                                                                                        } )
                                                                                                                                                                     }
                                                                                                                                                                     )
                                                                                                                                                               </div>
                                                                                                                                                      } )
                                                                                                                                                }
                                                                                                                                             </Fragment>
                                                                                                                                      }

                                                                                                                                      
                                                                                                                                 </div>  
                                                                                                                                

                                                                                                                              </td>
                                                                                                                           )
                                                                                                                     } )
                                                                                                                  }
                                                                                                         </tr>
                                                                                                   )
                                                                                             } )
                                                                                          }

                                                                                       </table>
                                                                                 </div>

                                          </div>


                                       </Fragment>
                                    }





                                    {
                                       itemSelected == 2 &&
                                       <Fragment>
 
                                                            <div className="table_widget">

                                                            <div className="btn" onClick={changeView} v="new" id="-1"  >zaplanuj czynność</div>

                                                            <Csv tabRef={tabRef} />

                                                            <Print tabRef={tabRef} />
                                                            
                                                            </div>

                                                            <div className="scorll_x">

                                                                 <table className="table" ref={tabRef} >

                                                                     <thead>
                                                                              <tr className="header">
                                                                                    <td className="td_left">LP</td>
                                                                                    <td>Dzień</td>
                                                                                    <td>Godzina</td>
                                                                                    <td>Temat</td>
                                                                                    <td>Forma aktywności</td>
                                                                                    <td>Cel dnia</td>
                                                                                    <td>Uwagi</td>
                                                                                    <td>Wymagane</td>
                                                                                    <td className="td_right">Powiązane grupy</td>
                                                                                                                                                                     
                                                                                    <td className="td_option"> </td>
                                                                                 
                                                                              </tr>
                                                                           </thead>

                                                                        {
                                                                           list.map( ( row, ix ) => {

                                                                                 var rowStyle = " row ";
                                                                                 if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                                 return <tr className={rowStyle} key={ix}>
                                                                                       <td className="gocenter" onClick={changeView} v="edit" id={row.id} >{ix+1}</td>
                                                                                       <td className="gocenter" onClick={changeView} v="edit" id={row.id} >  <div className="calColor" onClick={changeView} v="edit" id={row.id} >{row.dzien}</div></td>
                                                                                       <td className="gocenter" onClick={changeView} v="edit" id={row.id} >  <div className="" onClick={changeView} v="edit" id={row.id} >{row.godzina_wydarzenia}</div></td>
                                                                                       <td>{row.temat_dnia}</td>
                                                                                       <td>{row.forma_aktywnosci}</td>
                                                                                       <td>{row.cel_dnia}</td>
                                                                                       <td>{row.uwagi_dodatkowe}</td>
                                                                                       <td>{row.wymagane}</td>                                                   
                                                                                       <td className="gocenter">
                                                                                          {
                                                                                             row.grupy.map( (gg, gi) => {
                                                                                                return <span>
                                                                                                   {gg.nazwa}, &nbsp;
                                                                                                </span>
                                                                                             } )
                                                                                          }
                                                                                       </td>                                                   
                                                                                       <MenuTable>
                                                                                          <ul>                                             
                                                                                             <li onClick={changeView} v="edit" id={row.id} >zmień dane</li>                         
                                                                                             <li onClick={goDelete}  id={row.id}  title={row.temat_dnia} >usuń</li>
                                                                                          </ul>
                                                                                       </MenuTable>
                                                                                 </tr>

                                                                           } )
                                                                        }

                                                                     </table>

                                                            </div>
 
                                       </Fragment>
                                    }



     

                                    
                                    
                                 </div>

   </div>
}

export default CalendarYear;